import { render } from "./SurveyPage.vue?vue&type=template&id=70b1e75e&scoped=true"
import script from "./SurveyPage.vue?vue&type=script&lang=js"
export * from "./SurveyPage.vue?vue&type=script&lang=js"

import "./SurveyPage.vue?vue&type=style&index=0&id=70b1e75e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b1e75e"]])

export default __exports__